import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  X,
  ShoppingCart,
  Search,
  ChevronDown,
  ChevronRight,
  User,
  Heart,
  Facebook,
  Instagram,
  Twitter,
  LinkedinIcon,
  Send,
  AlertCircle,
} from "lucide-react";
import { useSelector } from "react-redux";
import { FaTiktok } from "react-icons/fa";

// Couleurs du drapeau du Niger
const COLORS = {
  orange: "#E87E04",
  white: "#FFFFFF",
  green: "#008751",
  darkGreen: "#006B3F",
  lightOrange: "#FFE0B2",
  lightGreen: "#CCFFCC",
  gray: "#718096",
  lightGray: "#E2E8F0",
  paleGreen: "#E6FFEA",
};
const BackendUrl = process.env.REACT_APP_Backend_Url;
const socialLinks = [
  {
    name: "tiktok",
    url: "https://www.tiktok.com/@amirseina?_t=ZN-8xhGdIjIl6I&_r=1",
    icon: <FaTiktok className="w-6 h-6" style={{ color: COLORS.green }} />,
  },
  {
    name: "Instagram",
    url: "https://instagram.com/kassarmou",
    icon: <Instagram className="w-6 h-6" style={{ color: COLORS.green }} />,
  },
  // {
  //   name: "Twitter",
  //   url: "https://twitter.com/kassarmou",
  //   icon: <Twitter className="w-6 h-6" style={{ color: COLORS.green }} />,
  // },
  // {
  //   name: "LinkedIn",
  //   url: "https://linkedin.com/company/kassarmou",
  //   icon: <LinkedinIcon className="w-6 h-6" style={{ color: COLORS.green }} />,
  // },
];
function HomeFooter2() {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState({
    isSubmitting: false,
    success: "",
    error: "",
  });
  const navigate = useNavigate();
  const DATA_Categories = useSelector((state) => state.products.categories);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterStatus({
      isSubmitting: true,
      success: "",
      error: "",
    });

    try {
      const normalizedEmail = newsletterEmail.trim().toLowerCase();
      if (!normalizedEmail) {
        throw new Error("Veuillez saisir votre adresse email");
      }

      await axios.post(`${BackendUrl}/api/newsletter/subscribe`, {
        email: normalizedEmail,
        source: "footer",
      });

      setNewsletterStatus({
        isSubmitting: false,
        success:
          "Inscription enregistrée. Vérifiez votre e-mail pour confirmer.",
        error: "",
      });
      setNewsletterEmail("");
    } catch (error) {
      setNewsletterStatus({
        isSubmitting: false,
        success: "",
        error:
          error?.response?.data?.message ||
          error.message ||
          "Erreur lors de l'inscription à la newsletter.",
      });
    }
  };
  // ➕ Affichage temporaire
  useEffect(() => {
    if (newsletterStatus.success || newsletterStatus.error) {
      const timeout = setTimeout(() => {
        setNewsletterStatus({ success: null, error: null });
      }, 3000); // 3 secondes

      return () => clearTimeout(timeout); // Clean si ça change trop vite
    }
  }, [newsletterStatus]);
  return (
    <div>
      {/* Footer */}
      <footer className="bg-gray-800 text-white pt-12 pb-6">
        <div className="container mx-auto px-4">
          {/* Footer top */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold mb-4">KASSARMOU</h3>
              <p className="text-gray-400 mb-4">
                Un pont entre traditions et authenticité. Nous vous proposons
                des produits artisanaux uniques, fabriqués avec soin et passion,
                reflétant le savoir-faire et la richesse culturelle du Niger.
              </p>
              <div className="flex space-x-4">
                {/* Social media icons placeholders */}

                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Visitez notre page ${social.name}`}
                    className="p-2 bg-white bg-opacity-20 rounded-full hover:bg-opacity-30 transition"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Liens rapides</h3>
              <ul className="space-y-2">
                <li style={{cursor:"pointer"}}>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Accueil
                  </a>
                </li>
                <li style={{cursor:"pointer"}}>
                  <a
                    onClick={() => navigate("/produits")}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Produits
                  </a>
                </li>
                <li style={{cursor:"pointer"}}>
                  <a
                    onClick={() => navigate("/AboutNigerPage")}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    À propos
                  </a>
                </li>
                {/* <li style={{cursor:"pointer"}}>
                  <a
                    onClick={() => navigate("/CGVPage")}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    CGVPage
                  </a>
                </li> */}
                {/* <li style={{cursor:"pointer"}}>
                  <a
                    onClick={() => navigate("/PolitiqueConfidentialitePage")}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Politique de confidentialite
                  </a>
                </li> */}
                <li style={{cursor:"pointer"}}>
                  <a
                    
                    onClick={() => navigate("/ContactPage")}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Catégories</h3>

              <ul>
                {DATA_Categories?.map((param, index) => {
                  // console.log(index);
                  if (index < 5) {
                    return (
                      <li key={index}>
                        <span
                          onClick={() => navigate("/produits")}
                          className="text-gray-400 hover:text-white transition-colors"
                          style={{ cursor: "pointer" }}
                        >
                          {param.name}
                        </span>
                      </li>
                    );
                  }
                })}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Contactez-nous</h3>
              <ul className="space-y-2 text-gray-400">
                <li>Belgique</li>
                <li>support@kassarmoumarket.com</li>
                <li>+32 465 96 54 36</li>
              </ul>
              {/* Messages d'état pour la newsletter */}
              {newsletterStatus.success && (
                <div className="mb-6 p-4 rounded-lg bg-green-50 border border-green-200 text-green-700">
                  {newsletterStatus.success}
                </div>
              )}

              {newsletterStatus.error && (
                <div className="mb-6 p-4 rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-start">
                  <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
                  <span>{newsletterStatus.error}</span>
                </div>
              )}
              <div className="mt-4">
                <h4 className="font-medium mb-2">Newsletter</h4>
                <form className="flex" onSubmit={handleNewsletterSubmit}>
                  <input
                    type="email"
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                    placeholder="Votre email"
                    className="px-4 py-2 w-full text-gray-800 rounded-l-lg focus:outline-none"
                  />
                  <button
                    type="submit"
                    className="px-4 py-2 text-white rounded-r-lg"
                    disabled={newsletterStatus.isSubmitting}
                    style={{
                      backgroundColor: newsletterStatus.isSubmitting
                        ? COLORS.gray
                        : COLORS.green,
                    }}
                  >
                    {newsletterStatus.isSubmitting ? (
                      <span className="flex items-center">
                        <svg
                          className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Traitement...
                      </span>
                    ) : (
                      <span className="flex items-center">
                        <Send className="w-4 h-4 mr-2" />
                        S'abonner
                      </span>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Footer bottom */}
          <div className="pt-6 border-t border-gray-700 text-sm text-gray-400 flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              &copy; 2025 Kassarmou. Tous droits réservés.
            </div>
            <div className="flex space-x-4">
              <a style={{cursor:"pointer"}} onClick={() => navigate("/CGVPage")} className="hover:text-white transition-colors">
                Conditions générales
              </a>
              <a style={{cursor:"pointer"}} onClick={() => navigate("/PolitiqueConfidentialitePage")} className="hover:text-white transition-colors">
                Politique de confidentialité
              </a>
              <a style={{cursor:"pointer"}} onClick={() => navigate("/SuppressionComptePage")} className="hover:text-white transition-colors">
                Suppression de compte
              </a>
              {/* <a href="#" className="hover:text-white transition-colors">
                Livraisons
              </a> */}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomeFooter2;
